import React, { FC, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useMetaMask } from '../context/MetaMaskContext';

import CrewMemberAPIService from '../services/crewMember.service';
import toast from 'react-hot-toast';

const crewMemberAPIService = new CrewMemberAPIService();

type ModalPurchaseNFTProps = {
  isOpen: boolean;
  toggle(): void;
  query: any;
};

const ModalJoinCrewMember: FC<ModalPurchaseNFTProps> = ({ isOpen, toggle, query }) => {
  const { metaMask } = useMetaMask();

  const joinCrewMember = async () => {
    try {
      await crewMemberAPIService.joinCrewMember(query.crew_id);
      toast.success(`You joined this project as ${query.role_name}`);
    } catch (error) {
      toast.error(`Invalid invitation url`);
      console.log(error);
    }
    toggle();
  };

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-join-crew-member">
        <ModalHeader toggle={toggle}>Join as {query.role_name} of this project</ModalHeader>
        <ModalBody>
          <div>{metaMask?.account}</div>
        </ModalBody>
        <ModalFooter>
          <button onClick={() => joinCrewMember()} className="app-btn color-primary">
            Join
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

ModalJoinCrewMember.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

ModalJoinCrewMember.defaultProps = {
  toggle: () => {},
};

export default ModalJoinCrewMember;
